/**
 * src/components/admin/AdminSolicitudes.js
 *
 * Tab de solicitudes pendientes en el panel admin.
 * Lee desde /data/solicitudes.json y permite aprobar o rechazar.
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { showToast } from './adminHelpers.js'
import { getSolicitudes, removeSolicitud } from '@/services/solicitudes.js'

define('AdminSolicitudes', ({ onApprove }) => {
    const root = h('div', {})

    root.appendChild(
        h('p', { style: 'padding:2rem;color:#64748b' }, '⏳ Cargando solicitudes…')
    )

    getSolicitudes().then(items => {
        root.innerHTML = ''

        if (!items.length) {
            root.appendChild(
                h('div', { className: 'admin-panel' },
                    h('div', { className: 'admin-panel__head' },
                        h('span', { className: 'admin-panel__title' }, '📬 Solicitudes pendientes'),
                        h('span', { className: 'admin-panel__count' }, '0 total')
                    ),
                    h('div', { className: 'adm-empty' },
                        h('div', { className: 'adm-empty__icon' }, '📭'),
                        h('div', { className: 'adm-empty__text' }, 'No hay solicitudes pendientes')
                    )
                )
            )
            return
        }

        const tbody = h('tbody', {})

        items.forEach(sol => {
            const tipo = sol._type === 'promo' ? '🎁 Promo' : `🏪 ${(sol.plan || 'plata').charAt(0).toUpperCase() + (sol.plan || 'plata').slice(1)}`
            const nombre = sol.name || sol.title || sol.business || '—'
            const fecha = sol._fecha ? new Date(sol._fecha).toLocaleDateString('es-CO') : '—'
            const responsable = sol.responsable || '—'
            const email = sol.contactEmail || '—'

            const approveBtn = h('button', { className: 'adm-btn adm-btn--primary adm-btn--sm', type: 'button' }, '✅ Aprobar')
            const rejectBtn = h('button', { className: 'adm-btn adm-btn--danger adm-btn--sm', type: 'button' }, '❌ Rechazar')
            const viewBtn = h('button', { className: 'adm-btn adm-btn--ghost adm-btn--sm', type: 'button' }, '👁 Ver')

            viewBtn.addEventListener('click', () => {
                const overlay = h('div', { className: 'adm-modal-overlay' },
                    h('div', { className: 'adm-modal' },
                        h('div', { className: 'adm-modal__head' },
                            h('span', { className: 'adm-modal__title' }, `📋 Solicitud: ${nombre}`),
                            (() => {
                                const btn = h('button', { className: 'adm-btn adm-btn--ghost adm-btn--sm adm-btn--icon', type: 'button' }, '✕')
                                btn.addEventListener('click', () => overlay.remove())
                                return btn
                            })()
                        ),
                        h('div', { className: 'adm-modal__body' },
                            h('pre', { style: 'white-space:pre-wrap;font-size:.8rem;max-height:60vh;overflow:auto;background:#f8fafc;padding:1rem;border-radius:8px' },
                                JSON.stringify(sol, null, 2)
                            )
                        )
                    )
                )
                overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove() })
                document.body.appendChild(overlay)
            })

            approveBtn.addEventListener('click', async () => {
                approveBtn.disabled = true
                rejectBtn.disabled = true
                approveBtn.textContent = '⏳…'
                try {
                    await removeSolicitud(sol._solId)
                    row.remove()
                    onApprove(sol)
                    showToast(`✅ "${nombre}" aprobada e importada (deshabilitada)`)
                } catch (err) {
                    showToast(`❌ Error: ${err.message}`, 5000)
                    approveBtn.disabled = false
                    rejectBtn.disabled = false
                    approveBtn.textContent = '✅ Aprobar'
                }
            })

            rejectBtn.addEventListener('click', async () => {
                if (!confirm(`¿Rechazar la solicitud de "${nombre}"? Se eliminará.`)) return
                rejectBtn.disabled = true
                rejectBtn.textContent = '⏳…'
                try {
                    await removeSolicitud(sol._solId)
                    row.remove()
                    showToast(`🗑 Solicitud de "${nombre}" rechazada`)
                } catch (err) {
                    showToast(`❌ Error: ${err.message}`, 5000)
                    rejectBtn.disabled = false
                    rejectBtn.textContent = '❌ Rechazar'
                }
            })

            const row = h('tr', {},
                h('td', {}, h('span', {
                    style: `background:${sol._type === 'promo' ? '#fef9c3' : '#dbeafe'};padding:.2rem .55rem;border-radius:99px;font-size:.75rem;font-weight:600`
                }, tipo)),
                h('td', {}, h('strong', {}, nombre)),
                h('td', {}, responsable),
                h('td', {}, email),
                h('td', {}, fecha),
                h('td', {}, h('div', { className: 'adm-row-actions' }, viewBtn, approveBtn, rejectBtn))
            )
            tbody.appendChild(row)
        })

        root.appendChild(
            h('div', { className: 'admin-panel' },
                h('div', { className: 'admin-panel__head' },
                    h('span', { className: 'admin-panel__title' }, '📬 Solicitudes pendientes'),
                    h('span', { className: 'admin-panel__count' }, `${items.length} total`)
                ),
                h('div', { style: 'overflow-x:auto' },
                    h('table', { className: 'admin-table' },
                        h('thead', {},
                            h('tr', {},
                                h('th', {}, 'Tipo'),
                                h('th', {}, 'Nombre'),
                                h('th', {}, 'Responsable'),
                                h('th', {}, 'Correo'),
                                h('th', {}, 'Fecha'),
                                h('th', {}, 'Acciones'),
                            )
                        ),
                        tbody
                    )
                )
            )
        )
    })

    return root
})
